module.exports = __webpack_public_path__ + "static/media/Tranquill_gaussian2.9ca4fc57.png";